module.exports = __webpack_public_path__ + "static/media/IMG_035.53752b2b.JPG";